
////////////////////// forms ///////////////////////////////////////////

export const EDIT_INSTANCE_FORM_NAME = "instanceUserEditorForm";

////////////////////// url ///////////////////////////////////////////

export const getHistoryUrlForInstanceUserDetail = ( organizationUuid, userIdAsEmail ) => {
    return `/organizations/${organizationUuid}/user/${userIdAsEmail}/detail`;
};

export const isInstanceUserDetailOnThisPath = (locationReduxVariable) => {
    let url = locationReduxVariable.pathname;
    let match = url.match(new RegExp('organizations/([^/]+)/user/([^/]+)/detail'));
    if (match) {
        return true;
    }
};

export const getInstanceUuidFromLocation = (locationReduxVariable) => {
    let url = locationReduxVariable.pathname;
    let match = url.match(new RegExp('organizations/([^/]+)/user/([^/]+)/detail'));
    if (match) {
        return match[1];
    }
};

export const getUserDetailIdFromLocation = (locationReduxVariable) => {
    let url = locationReduxVariable.pathname;
    let match = url.match(new RegExp('organizations/([^/]+)/user/([^/]+)/detail'));
    if (match) {
        return match[2];
    }
};

export const getOrganizationIdFromLocation = (locationReduxVariable) => {
    let url = locationReduxVariable.pathname;
    let match = url.match(new RegExp('organizations/([^/]+)/user/([^/]+)/detail'));
    if (match) {
        return match[1];
    }
};




// WEBPACK FOOTER //
// ./src/Atollon/pages/InstanceUserDetail/shared.js